import styled from 'styled-components';

export const PageContentContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: auto;
    margin: 0 auto;
    margin-top: -21px;
    margin-bottom: -21px;
    background-size: 100% 531px;
`;